export default __webpack_public_path__ + "static/317-bece31f00b5f8d06b5a8c95a7405faef.gif";